/* eslint-disable security/detect-object-injection */
import {ConfigService, events} from '@nuskin/ns-util';

const {googleUrlId} = ConfigService.getMarketConfig();

class NsGtm {
    get dataLayer() {
        return window.dataLayer;
    }

    get tag() {
        return events.tag;
    }

    // See https://developers.google.com/tag-manager/quickstart
    load(gtmId) {
        const l = 'dataLayer';
        if (!document.querySelector('[src*="www.googletagmanager.com/gtm.js"]')) {
            const gtmScript = document.createElement('script');
            gtmScript.async = true;
            gtmScript.src = 'https://www.googletagmanager.com/gtm.js?id=' + gtmId + '&l=' + l;

            document.head.appendChild(gtmScript);

            window[l] = window[l] || [];
            window[l].push({'gtm.start': new Date().getTime(), 'event': 'gtm.js'});
        }
    }
}

const gtm = new NsGtm();
gtm.load(googleUrlId);

export default gtm;
